import React from "react";

import { ConditionalShopTileBlock as Value } from "@reactivated";

import { ShopTileType } from "../ShopCompareTypes";
import { ShopTileContent } from "../elements/ShopTileContent";

interface IShopTileProps {
    value: Value;
    tilesetId: number;
    compactPricing?: boolean;
}

export const ShopTile = (props: IShopTileProps) => {
    return (
        <ShopTileContent
            tilesetId={props.tilesetId}
            value={props.value as ShopTileType}
            compactPricing={props.compactPricing}
        />
    );
};
